import draftsApi from '@/services/api/drafts'
import useServerList from '@/composables/useServerList'

/**
 * Start of the current ACA year (1 April; before April it's last year's) — the same default
 * the legacy DataTable AdvancedFilter sent as `from_date` on the /drafts-list page.
 */
export function acaYearStart() {
  const now = new Date()
  const year = now.getMonth() + 1 <= 3 ? now.getFullYear() - 1 : now.getFullYear()
  return `${year}-04-01`
}

/**
 * Admin /drafts-list table state (page / sort / per-page / search / tab / date range),
 * URL-synced via useServerList. The endpoint is admin-only, so there is no per-role scope here.
 * Rows are passed through raw (snake_case, as the API returns them) so the Edit link can hand
 * the untouched draft object to the Create Draft screen the way the legacy page did.
 */
export default function useDraftsList() {
  return useServerList(draftsApi.getList, {
    defaultSort: 'start_date',
    defaultDirection: 'asc',
    defaultPerPage: 20,
    extraFilters: {
      tab: 'all',
      from_date: acaYearStart(),
      to_date: '',
      committee_id: '',
      zone_id: [],
      // Unpublished / Deleted / Open for Nominations (CAM-1503) — each narrows on top of
      // tab/zone/date/search, but the three are mutually exclusive with each other (checking one
      // clears the other two, enforced in Drafts.vue's setExclusiveCheckbox). Plain '' / '1'
      // scalars (not real booleans) keep them out of the URL/request when unset, same convention
      // as every other scalar filter here.
      unpublished: '',
      deleted: '',
      open_for_nominations: ''
    }
  })
}



// WEBPACK FOOTER //
// ./src/composables/drafts/useDraftsList.js